<div class="pnc-create-page-header grid-container">
  <h1 class="pnc-create-page-title"
  data-cy="pnc-create-page-title">CREATE A NEW PNC</h1>
  @if (hasAnyPncType) {
    <div>
      <app-status-timeline [configuration]=mapStatusTimelineToConfigurationModel()></app-status-timeline>
    </div>
  }
</div>

@if (hasPncTypes) {
  <app-input-radio #pncTypeInput
    (inputStateChange)="pncTypeStateChange($event)"
    (inputValueChange)="pncTypeValueChange($event)"
    [initialValue]="initialOption"
    [optionTransform]="pncTypeTransform"
    [options]="pncTypes"
    label="Type of PNC?">
  </app-input-radio>
}

<section class="pnc-create-form-header {{pncTypeCssClass}}"
  data-cy="pnc-create-form-header">
  <div class="pnc-create-form-header-title"
    data-cy="pnc-create-form-header-title">{{state?.type?.name}}
  </div>
</section>
<div class="pnc-create-form {{pncTypeCssClass}}" data-cy="pnc-create-form">
  <ng-container #credentialsContainer></ng-container>
  <ng-container #oldPartNumberContainer></ng-container>
  <ng-container #solutionContainer></ng-container>
</div>

<section class="pnc-create-form-footer"
  data-cy="pnc-create-form-footer">
  <ng-container #footerContainer></ng-container>
</section>

@if (spinnerObservable | async) {
  <div class="spinner-container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
